export var CLASS_NAME_PREFIX = "dc-markdown";